export default {
    cz: {
        price: (unit: string) => `cena za ${unit}`,
        withDPH: 's DPH',
    },
    sk: {
        price: (unit: string) => `cena za ${unit}`,
        withDPH: 's DPH',
    },
}
